var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bl-target-progress-container",
      class: {
        "bl-target-progress-container-empty":
          !_vm.entries || !_vm.entries.length
      }
    },
    [
      _vm.readonly
        ? _c("div", { staticClass: "relative w-full" }, [
            _c("div", { staticClass: "flex-shrink-0 w-full h-14" }),
            _vm._v(" "),
            _c("div", { staticClass: "absolute w-full -top-6" }, [
              _c(
                "div",
                {
                  staticClass: "flex items-center gap-2 px-4 py-2 bg-info-100"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid flex-shrink-0 w-10 h-10 place-items-center",
                      style: { background: "#E4F1FA", borderRadius: "0.25rem" }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-6 h-6",
                        attrs: { icon: "toast-info" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextBody1", {
                    staticClass: "text-info",
                    attrs: {
                      text:
                        "All data displayed is mock information, used for post-session visual representation."
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      (!_vm.entries || !_vm.entries.length) && !_vm.readonly
        ? _c(
            "span",
            { staticClass: "px-6 bl-target-progress-message" },
            [
              _c("BlTextBody2", {
                attrs: {
                  text:
                    "Don't see any records yet? No problem! They'll start appearing as soon as you"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cursor-pointer ",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        path: "/clients/" + _vm.$route.params.id + "/session"
                      })
                    }
                  }
                },
                [
                  _c("BlTextSubtitle3", {
                    staticClass: "bl-target-progress-message-highlight",
                    attrs: { text: "start sessions." }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.entries.length
        ? _c(
            "div",
            { staticClass: "px-6 bl-target-progress-graph" },
            [
              _vm.chartLoading
                ? _c("div", { staticClass: "absolute z-20 w-full h-full" }, [
                    _c("div", {
                      staticClass:
                        "absolute w-full h-full opacity-75 bg-pure-white"
                    }),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.target.type.includes("Sbt")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center gap-2 p-3 mb-5 bg-slate-200"
                    },
                    [
                      _c(
                        "div",
                        {
                          class: { "cursor-pointer": _vm.taskTarget },
                          on: {
                            click: function($event) {
                              _vm.taskTarget
                                ? _vm.$emit("updateTaskTarget", null)
                                : ""
                            }
                          }
                        },
                        [
                          _c("BlTextSubtitle3", {
                            class: [
                              _vm.taskTarget
                                ? "text-slate-600"
                                : "text-slate-700"
                            ],
                            attrs: { text: _vm.target.name }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.taskTarget
                            ? _c("BlTextSubtitle3", {
                                staticClass: "text-slate-600",
                                attrs: { text: "/" }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.taskTarget
                            ? _c("BlTextSubtitle3", {
                                staticClass: "text-slate-700",
                                attrs: {
                                  text:
                                    _vm.taskTarget.code +
                                    " - " +
                                    _vm.taskTarget.code_definition
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "bl-target-progress-graph-header" }, [
                _c(
                  "div",
                  { staticClass: "bl-target-progress-graph-title-container" },
                  [
                    _c("BlTextSubtitle1", {
                      staticClass: "bl-target-progress-graph-title",
                      attrs: { text: "Progress" }
                    }),
                    _vm._v(" "),
                    _c("BlBubbleCount", {
                      attrs: {
                        count: _vm.entries.filter(function(i) {
                          return !i.type.includes("PhaseLine")
                        }).length
                      }
                    }),
                    _vm._v(" "),
                    _vm.target.type.includes("Prompting")
                      ? _c("BlSelectBox", {
                          key:
                            "select-" +
                            JSON.stringify(_vm.graphProgressByOptions),
                          staticClass: "w-40",
                          attrs: {
                            dense: "",
                            options: _vm.graphProgressByOptions
                          },
                          on: {
                            change: function($event) {
                              _vm.graphProgressBy = $event
                            }
                          },
                          model: {
                            value: _vm.graphProgressBy,
                            callback: function($$v) {
                              _vm.graphProgressBy = $$v
                            },
                            expression: "graphProgressBy"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "relative flex items-center gap-2",
                    attrs: { id: "chart-legends" }
                  },
                  [
                    _c("BlTextBody2", { attrs: { text: "Show" } }),
                    _vm._v(" "),
                    _vm.isTargetHasTrendline
                      ? _c("BlInputButton", {
                          class: { "border-light-purple": _vm.isTrendlineShow },
                          attrs: {
                            label: "Trendline",
                            type: "outlined",
                            dense: ""
                          },
                          on: {
                            clicked: function($event) {
                              _vm.isTrendlineShow = !_vm.isTrendlineShow
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTargetHasAverage
                      ? _c("BlInputButton", {
                          class: { "border-light-purple": _vm.isAverageShow },
                          attrs: {
                            label: "Average",
                            type: "outlined",
                            dense: ""
                          },
                          on: {
                            clicked: function($event) {
                              _vm.isAverageShow = !_vm.isAverageShow
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      class: { "border-light-purple": _vm.isGridShow },
                      attrs: { label: "Grid", type: "outlined", dense: "" },
                      on: {
                        clicked: function($event) {
                          _vm.isGridShow = !_vm.isGridShow
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "relative" },
                      [
                        _c("BlInputButton", {
                          staticClass: "border-light-purple",
                          attrs: {
                            icon: "line-chart",
                            label: "View legends",
                            type: "outlined",
                            dense: ""
                          },
                          on: {
                            clicked: function($event) {
                              _vm.isLegendPopupShow = !_vm.isLegendPopupShow
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.isLegendPopupShow
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "absolute right-0 z-50 mt-2 border rounded bg-pure-white border-slate-400",
                                attrs: { "data-id": _vm.popupId }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col w-48 gap-2 px-3 py-3",
                                    attrs: { "data-id": _vm.popupId }
                                  },
                                  [
                                    _c("BlTextSubtitle3", {
                                      staticClass: "text-slate-700",
                                      attrs: {
                                        "data-id": _vm.popupId,
                                        text: "Legends"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.isTargetHasGoal
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-2",
                                            attrs: { "data-id": _vm.popupId }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "flex-shrink-0 w-10 h-1 rounded",
                                              style: {
                                                backgroundColor: "#71C115"
                                              },
                                              attrs: { "data-id": _vm.popupId }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              attrs: {
                                                "data-id": _vm.popupId,
                                                text: "Goal"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isTargetHasTrendline
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-2",
                                            attrs: { "data-id": _vm.popupId }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "flex-shrink-0 w-10 h-1 rounded",
                                              style: {
                                                background:
                                                  "repeating-linear-gradient(90deg, #6750A4 0 8px, white 0 12px)"
                                              },
                                              attrs: { "data-id": _vm.popupId }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              attrs: {
                                                "data-id": _vm.popupId,
                                                text: "Trendline"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isTargetHasAverage
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-2",
                                            attrs: { "data-id": _vm.popupId }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "flex-shrink-0 w-10 h-1 rounded",
                                              style: {
                                                background:
                                                  "repeating-linear-gradient(90deg, #71C115 0 8px, white 0 12px)"
                                              },
                                              attrs: { "data-id": _vm.popupId }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              attrs: {
                                                "data-id": _vm.popupId,
                                                text: "Average line"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2",
                                        attrs: { "data-id": _vm.popupId }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "flex-shrink-0 w-10 h-1 rounded",
                                          style: {
                                            background:
                                              "repeating-linear-gradient(90deg, #E4E4E4 0 8px, white 0 12px)"
                                          },
                                          attrs: { "data-id": _vm.popupId }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: {
                                            "data-id": _vm.popupId,
                                            text: "Phase line"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.phaseLineCount === 0 &&
                                    (!_vm.target.type.includes("Prompting") ||
                                      _vm.graphProgressBy === "final_score") &&
                                    !_vm.target.type.includes("Sbt")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-2",
                                            attrs: {
                                              "data-id": _vm.popupId,
                                              title: _vm.target.name
                                            }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "flex-shrink-0 w-10 h-1 rounded",
                                              style: {
                                                backgroundColor: "#9A8AC2"
                                              },
                                              attrs: { "data-id": _vm.popupId }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              staticClass: "truncate",
                                              attrs: {
                                                "data-id": _vm.popupId,
                                                text: _vm.target.name
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.target.type.includes("Prompting") &&
              (_vm.graphProgressBy === "frequency" ||
                _vm.graphProgressBy === "percentage")
                ? _c("div", { attrs: { id: "prompting-selection-legends" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center flex-shrink-0 w-full gap-3 px-5 py-2 overflow-x-auto scrollbar-lg"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                            class: [
                              _vm.isPromptingShowAll
                                ? "border-light-purple-300"
                                : "border-grey-200"
                            ],
                            on: {
                              click: function($event) {
                                return _vm.onTogglePromptingShow("all")
                              }
                            }
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "flex-shrink-0 h-4",
                              attrs: { icon: "prompt-line" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "capitalize-first",
                              attrs: { text: "All graphs" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.defaultPrompts, function(prompt) {
                          return _c(
                            "div",
                            {
                              key: prompt.id,
                              staticClass:
                                "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                              class: [
                                prompt.is_show
                                  ? "border-light-purple-300"
                                  : "border-grey-200"
                              ],
                              attrs: { title: prompt.name },
                              on: {
                                click: function($event) {
                                  return _vm.onTogglePromptingShow(prompt)
                                }
                              }
                            },
                            [
                              prompt.shape && prompt.color
                                ? _c("BlIcon", {
                                    staticClass: "flex-shrink-0 w-auto h-4",
                                    attrs: {
                                      icon: "prompt-" + prompt.shape,
                                      color: prompt.color
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "w-24 truncate capitalize-first",
                                attrs: { text: prompt.name }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.target.type.includes("Sbt")
                ? _c("div", { attrs: { id: "task-selection-legends" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center flex-shrink-0 w-full gap-3 px-5 py-2 overflow-x-auto scrollbar-lg"
                      },
                      [
                        _vm.taskTarget
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                                class: [
                                  _vm.taskTarget.is_show && _vm.isPbShowAll
                                    ? "border-light-purple-300"
                                    : "border-grey-200"
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.onToggleTaskTargetShow("all")
                                  }
                                }
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "flex-shrink-0 h-4",
                                  attrs: { icon: "prompt-line" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "capitalize-first",
                                  attrs: { text: "All Graphs" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.taskTarget
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                                class: [
                                  _vm.isTaskShowAll
                                    ? "border-light-purple-300"
                                    : "border-grey-200"
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.onToggleTaskShow(
                                      "allTasks",
                                      "task"
                                    )
                                  }
                                }
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "flex-shrink-0 h-4",
                                  attrs: { icon: "prompt-line" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "capitalize-first",
                                  attrs: { text: "All Tasks" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.taskTarget
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 overflow-hidden flex-shrink-0 text-center border rounded cursor-pointer",
                                class: [
                                  _vm.isPbShowAll
                                    ? "border-light-purple-300"
                                    : "border-grey-200"
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.onToggleTaskShow(
                                      "allProblemBehaviors",
                                      "pb"
                                    )
                                  }
                                }
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "flex-shrink-0 h-4",
                                  attrs: { icon: "prompt-line" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "truncate capitalize-first",
                                  style: {
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "70px"
                                  },
                                  attrs: {
                                    text: "All Problem Behaviors",
                                    title: "All Problem Behaviors"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.taskTarget
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                                class: [
                                  _vm.taskTarget.is_show
                                    ? "border-light-purple-300"
                                    : "border-grey-200"
                                ],
                                attrs: { title: _vm.taskTarget.code },
                                on: {
                                  click: function($event) {
                                    return _vm.onToggleTaskTargetShow()
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "h-4" }, [
                                  _c("div", {
                                    staticClass: "flex-shrink-0 w-12",
                                    style: {
                                      backgroundColor: _vm.taskTarget.color,
                                      height: "2px"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "w-24 truncate capitalize-first",
                                  attrs: { text: _vm.taskTarget.code }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.defaultTasks, function(task) {
                          return !_vm.taskTarget
                            ? _c(
                                "div",
                                {
                                  key: "task-" + task.id,
                                  staticClass:
                                    "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                                  class: [
                                    task.is_show
                                      ? "border-light-purple-300"
                                      : "border-grey-200"
                                  ],
                                  attrs: { title: task.code },
                                  on: {
                                    click: function($event) {
                                      return _vm.onToggleTaskShow(task, "task")
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "h-4" }, [
                                    _c("div", {
                                      staticClass: "flex-shrink-0 w-12",
                                      style: {
                                        backgroundColor: task.color,
                                        height: "2px"
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass:
                                      "w-24 truncate capitalize-first",
                                    attrs: { text: task.code }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.defaultProblemBehaviors, function(pb) {
                          return _c(
                            "div",
                            {
                              key: "problem-behavior-" + pb.id,
                              staticClass:
                                "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                              class: [
                                pb.is_show
                                  ? "border-light-purple-300"
                                  : "border-grey-200"
                              ],
                              attrs: { title: pb.code },
                              on: {
                                click: function($event) {
                                  return _vm.onToggleTaskShow(pb, "pb")
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "h-4 mb-1" }, [
                                _c("div", {
                                  staticClass: "flex-shrink-0 w-5",
                                  style: {
                                    backgroundColor: pb.color,
                                    height: "14px",
                                    borderRadius: "2px"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "w-24 truncate capitalize-first",
                                attrs: { text: pb.code }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("ProgressGraph", {
                key: _vm.target.id + "-" + _vm.chartKey + "-scrollable",
                attrs: {
                  graphData: _vm.chartDatas,
                  targetType: _vm.target.type,
                  isGridShow: _vm.isGridShow,
                  present: _vm.graphProgressBy
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.entries && _vm.entries.length
        ? _c(
            "div",
            { staticClass: "bl-target-progress-entries" },
            [
              _c(
                "div",
                { staticClass: "flex items-center justify-between px-6 py-5" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-4" },
                    [
                      _c("BlTextSubtitle1", {
                        attrs: { text: "Session records" }
                      }),
                      _vm._v(" "),
                      _vm.target.type.includes("Prompting")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "p-0.5 flex justify-between border-2 border-slate-400 rounded text-slate-700 bg-slate-400 text-sm font-bold",
                              attrs: { id: "toggle-score-precentage" }
                            },
                            _vm._l(_vm.entryProgressByOptions, function(opt) {
                              return _c(
                                "div",
                                {
                                  key: opt.value,
                                  staticClass:
                                    "flex items-center justify-center h-7.5 px-4 rounded cursor-pointer",
                                  class: [
                                    _vm.entryProgressBy === opt.value
                                      ? "bg-pure-white"
                                      : "bg-slate-400"
                                  ],
                                  attrs: { title: opt.title },
                                  on: {
                                    click: function($event) {
                                      _vm.entryProgressBy = opt.value
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(opt.label) +
                                      "\n          "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.readonly
                    ? _c(
                        "div",
                        { staticClass: "flex items-center gap-4" },
                        [
                          !_vm.target.type.includes("Sbt")
                            ? _c(
                                "div",
                                {
                                  attrs: {
                                    title: !_vm.phaseLineCount
                                      ? "Must have phase line to rearrange"
                                      : ""
                                  }
                                },
                                [
                                  _c("BlInputButton", {
                                    attrs: {
                                      type: "outlined",
                                      disabled: !_vm.phaseLineCount,
                                      label: "Rearrange"
                                    },
                                    on: {
                                      clicked: function($event) {
                                        _vm.rearrangeState = true
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.target.type.includes("Sbt")
                            ? _c("BlInputButton", {
                                attrs: { icon: "plus", label: "Phase line" },
                                on: {
                                  clicked: function($event) {
                                    _vm.newPhaseLineOpened = true
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.rearrangeState
                ? _c("div", { staticClass: "absolute z-10 w-full px-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center justify-between w-full p-3 border bg-grey-100 rounded-xl border-grey-200"
                      },
                      [
                        _c("BlTextBody1", {
                          staticClass: "text-grey-400",
                          attrs: {
                            text:
                              "To rearrange the phase, drag the box and position it between the data."
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-4" },
                          [
                            _c("BlInputButton", {
                              attrs: { type: "plain", label: "Close" },
                              on: {
                                clicked: function($event) {
                                  _vm.rearrangeState = false
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "relative pb-40 overflow-x-auto scrollbar-lg" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center flex-grow",
                      attrs: { id: "entries-header" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sticky left-0 z-10 flex pl-6 bg-pure-white"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 w-32 h-12 px-2 border-b border-slate-400 bg-pure-white",
                              attrs: { id: "date-header" }
                            },
                            [_c("BlTextBody1", { attrs: { text: "Date" } })],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.target.type.includes("Percentage") ||
                      _vm.target.type.includes("Pir")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 w-16 h-12 px-2 border-b border-slate-400 bg-pure-white",
                              attrs: { id: "score-header" }
                            },
                            [_c("BlTextBody1", { attrs: { text: "Score" } })],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.target.type.includes("Pir")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-2 border-b w-28 border-slate-400 bg-pure-white",
                              attrs: { id: "percentage-header" }
                            },
                            [
                              _c("BlTextBody1", {
                                attrs: { text: "Percentage" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.target.type.includes("Duration")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 w-32 h-12 px-2 border-b border-slate-400 bg-pure-white",
                              attrs: { id: "duration-header" }
                            },
                            [
                              _c("BlTextBody1", {
                                attrs: { text: "Recorded time" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.target.type.includes("Frequency")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 w-24 h-12 px-2 border-b border-slate-400 bg-pure-white",
                              attrs: { id: "frequency-header" }
                            },
                            [
                              _c("BlTextBody1", {
                                attrs: { text: "Frequency" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.target.type.includes("Prompting")
                        ? _c(
                            "div",
                            {
                              staticClass: "flex items-center flex-shrink-0",
                              attrs: { id: "prompts-header" }
                            },
                            [
                              _vm.entryProgressBy === "final_score"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center flex-shrink-0 h-12 px-2 border-b w-28 border-slate-400 bg-pure-white"
                                    },
                                    [
                                      _c("BlTextBody1", {
                                        attrs: { text: "Final score" }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._l(_vm.defaultPrompts, function(prompt) {
                                    return _c(
                                      "div",
                                      {
                                        key: prompt.id,
                                        staticClass:
                                          "flex items-center justify-center flex-shrink-0 h-12 px-2 transition-all duration-300 border-b border-slate-400 bg-pure-white",
                                        class: {
                                          "w-12":
                                            _vm.entryProgressBy === "score",
                                          "w-16":
                                            _vm.entryProgressBy === "percentage"
                                        }
                                      },
                                      [
                                        _c("BlTextBody1", {
                                          attrs: { text: prompt.abbreviation }
                                        })
                                      ],
                                      1
                                    )
                                  })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.target.type.includes("Sbt") && !_vm.taskTarget
                        ? _c(
                            "div",
                            {
                              staticClass: "flex items-center flex-shrink-0",
                              attrs: { id: "task-header" }
                            },
                            _vm._l(_vm.defaultTasks, function(task) {
                              return _c(
                                "div",
                                {
                                  key: task.id,
                                  staticClass:
                                    "flex items-center justify-center flex-shrink-0 w-16 h-12 px-2 border-b border-slate-400 bg-pure-white"
                                },
                                [
                                  _c("BlTextBody1", {
                                    attrs: { text: task.code }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.target.type.includes("Sbt") && _vm.taskTarget
                        ? _c(
                            "div",
                            {
                              staticClass: "flex items-center flex-shrink-0",
                              attrs: { id: "task-header" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-center flex-shrink-0 w-16 h-12 px-2 border-b border-slate-400 bg-pure-white"
                                },
                                [
                                  _c("BlTextBody1", {
                                    attrs: { text: _vm.taskTarget.code }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.target.type.includes("Sbt") && _vm.taskTarget
                        ? _c(
                            "div",
                            {
                              staticClass: "flex items-center flex-shrink-0",
                              attrs: { id: "problem-behavior-header" }
                            },
                            _vm._l(_vm.defaultProblemBehaviors, function(pb) {
                              return _c(
                                "div",
                                {
                                  key: pb.id,
                                  staticClass:
                                    "flex items-center justify-center flex-shrink-0 w-16 h-12 px-2 border-b border-slate-400 bg-pure-white"
                                },
                                [
                                  _c("BlTextBody1", {
                                    attrs: { text: pb.code }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 w-32 h-12 px-2 border-b border-slate-400 bg-pure-white",
                          attrs: { id: "recorded-by-header" }
                        },
                        [_c("BlTextBody1", { attrs: { text: "Recorded by" } })],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.taskTarget
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-grow flex-shrink-0 h-12 px-2 border-b w-80 border-slate-400 bg-pure-white",
                              attrs: { id: "comment-header" }
                            },
                            [_c("BlTextBody1", { attrs: { text: "Comment" } })],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "flex flex-col",
                      class: { "pointer-events-none": _vm.readonly },
                      attrs: { handle: ".handle" },
                      on: {
                        update: function($event) {
                          $event.preventDefault()
                          return _vm.onMovePosition($event)
                        }
                      }
                    },
                    _vm._l(_vm.entries, function(entry) {
                      return _c(
                        "div",
                        { key: "entry-" + entry.id, attrs: { id: entry.id } },
                        [
                          entry.type.includes("PhaseLine")
                            ? _c("EntryPhaseLine", {
                                key:
                                  "phase-line-entry-" +
                                  entry.id +
                                  "-" +
                                  entry.position,
                                attrs: {
                                  entry: entry,
                                  rearrangeState: _vm.rearrangeState,
                                  isPrompting: _vm.target.type.includes(
                                    "Prompting"
                                  )
                                }
                              })
                            : entry.type.includes("Frequency")
                            ? _c("EntryFrequency", {
                                key:
                                  "frequency-entry-" +
                                  entry.id +
                                  "-" +
                                  entry.position,
                                attrs: { entry: entry }
                              })
                            : entry.type.includes("Prompting")
                            ? _c("EntryPrompt", {
                                key:
                                  "prompting-entry-" +
                                  entry.id +
                                  "-" +
                                  entry.position,
                                attrs: {
                                  entry: entry,
                                  promptColors: _vm.promptColors,
                                  prompts: _vm.defaultPrompts,
                                  progressBy: _vm.entryProgressBy,
                                  format: _vm.target.prompting_format
                                }
                              })
                            : entry.type.includes("Sbt")
                            ? _c("EntryPromptSbt", {
                                key:
                                  "prompting-sbt-entry-" +
                                  entry.id +
                                  "-" +
                                  entry.position,
                                attrs: {
                                  entry: entry,
                                  promptColors: _vm.promptSbtColors,
                                  tasks: _vm.defaultTasks,
                                  problemBehaviors: _vm.defaultProblemBehaviors,
                                  prompts: _vm.defaultPrompts,
                                  taskTarget: _vm.taskTarget,
                                  dataFormat: "prompt_score"
                                },
                                on: { "select-task": _vm.selectTask }
                              })
                            : _c("Entry", {
                                key:
                                  "other-entry-" +
                                  entry.id +
                                  "-" +
                                  entry.position,
                                attrs: { entry: entry }
                              })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "w-full px-6 my-6 text-center",
                staticStyle: { opacity: "0.375" },
                attrs: { text: "You have reached the end." }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newPhaseLineOpened
        ? _c("NewPhaseLineModal", {
            attrs: {
              targetId: _vm.target.id,
              hasPhaseLine: _vm.phaseLineCount > 0,
              isPrompting: _vm.target.type.includes("Prompting")
            },
            on: {
              "close-modal": function($event) {
                _vm.newPhaseLineOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "absolute z-20 grid w-full h-full place-items-center" },
      [_c("div", { staticClass: "blum-loader" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "sticky right-0 z-10 flex pr-6 bg-pure-white",
        attrs: { id: "menu-header" }
      },
      [
        _c("div", {
          staticClass:
            "flex items-center flex-shrink-0 w-12 h-12 px-4 border-b border-slate-400 bg-pure-white"
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c6ec2ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c6ec2ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/PropertyProgress.vue
// module id = null
// module chunks = 